<!--
@Author: Calvin Green <calvin>
@Date:   2021-12-08T21:53:17+02:00
@Email:  calvin@diversitude.com
@Last modified by:   calvin
@Last modified time: 2022-04-09T18:27:45+02:00
@Copyright: Diversitude 2021
-->



<template>
    <b-modal size="lg" title="Add Attachment" hide-footer id="addSopModal">
        <b-overlay :show="hasMounted == false">
            <div class="modal-body" style="width: 100%;">
                <b-form @submit="saveAttachment">
                    <b-form-group
                      class="mb-4"
                      label="Name: "
                      label-for="attachment-name"
                      label-cols-sm="3"
                    >
                      <b-form-input
                        id="attachment-name"
                        type="text"
                        v-model="attachmentData.name"
                      ></b-form-input>
                    </b-form-group>

                    <b-form-group
                      class="mb-4"
                      label="Description: "
                      label-for="attachment-description"
                      label-cols-sm="3"
                    >
                      <b-form-input
                        id="attachment-description"
                        type="text"
                        v-model="attachmentData.description"
                      ></b-form-input>
                    </b-form-group>

                    <b-form-group
                      class="mb-4"
                      label="Type: "
                      label-for="attachment-type"
                      label-cols-sm="3"
                    >
                        <b-form-select v-model="attachmentData.type" :options="typeOpts"></b-form-select>
                    </b-form-group>

                </b-form>
                <uploader :options="renderUploadOptions()" :autoStart="false" :ref="'attach_upload'" class="uploader-example">
                    <uploader-unsupport></uploader-unsupport>
                        <uploader-drop>
                            <p>Drop file here to upload or</p>
                            <uploader-btn type="button" :single="false"><i class="fas fa-file fa-fw"></i> Select file</uploader-btn>&nbsp;
                        </uploader-drop>
                    <uploader-list></uploader-list>
                </uploader>
            </div>
        </b-overlay>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" @click="saveAttachment()">Save</button>
          <button type="button" class="btn btn-secondary" @click="hideModal()">Close</button>
        </div>
    </b-modal>
</template>

<script>
//import _ from 'lodash';
import Swal from "sweetalert2";
import { sopAdminMethods, sopAdminState } from '@/state/helpers.js'
export default {
    props:{
        sop_type_id:{
            required: true 
        }
    },
    data:() => ({
        hasMounted: false,
        attachmentData: {
            name: "",
            description: "",
            type: "image"
        },
        typeOpts: [
            { value: '', text: 'Please select an option'},
            { value: 'image', text: 'Image' },
            { value: 'pdf', text: 'PDF' },
            //{ value: 'docx', text: 'Word' }
        ],
        /*ui:{
            id:'viewsTable',
            view: 'datatable',
            css: "datatableApplicants",
            select: 'row',
            hover: 'row-hover',
            autoheight: true,
            fillspace: true,
            data:[],
            columns:[
                { id: 'name', header: 'Name', fillspace: true},
                { id: 'description', header: 'Description', fillspace: 1.4},
                //eslint-disable-next-line
                { id: 'actions', header: 'Actions', fillspace: 0.6, template(obj, common, value){
                    return  '<span><b-button class="webix_button delete_button">Add</b-button></span>'
                }}
            ]
        }*/
    }),
    computed:{
        ...sopAdminState,
        /*return_views(){
            let data = [];
            if(this.views != null){
                data = _.cloneDeep(this.views);
            }
            return data;
        }*/
    },
    methods:{
        ...sopAdminMethods,
        saveAttachment() {
            if (this.attachmentData.name == "" || this.attachmentData.type == "") {
                Swal.fire("Error", "Check your form!", "error");
                return;
            }
            const uploaderInstance = this.$refs['attach_upload'];
            const upload = uploaderInstance.uploader;
            upload.opts.query.type = this.attachmentData.type;
            upload.opts.query.name = this.attachmentData.name;
            upload.opts.query.description = this.attachmentData.description;
            upload.resume();
            //eslint-disable-next-line no-unused-vars
            upload.on('fileSuccess', (rootFile, file, message, chunk)=>{
                let response = JSON.parse(message);
                if(response.success){
                    //eslint-disable-next-line no-console
                    //this.getAllAttachments();
                    this.loadSopData(this.sop_type_id);
                    this.hideModal();
                    Swal.fire("Uploaded", "Your attachment has been uploaded!", "success");
                    //console.log("Upload success", file)
                    upload.off("fileSuccess");
                    upload.cancel();
                }
                else {
                   //eslint-disable-next-line no-console
                    console.log("Upload error");
                }
            });
        },
        resetAttachment() {

        },
        hideModal() {
            this.$bvModal.hide("addSopModal");
        },
        renderUploadOptions() {
            let storage = window.localStorage;
            let AUTH_TOKEN = storage.getItem('x_token');
            let url = process.env.VUE_APP_API_BASEURL + 'api/clientdocadmin/uploadattachment';
            let options = {
                target: url,
                query: {
                    client_sop_type_id: this.sop_type_id,
                },
                headers: {
                    'Authorization': 'Bearer ' + AUTH_TOKEN,
                },
                testChunks: false,
                withCredentials: true,
                fileParameterName: 'attachment', //Set the upload post param which will contain the binary payload
                singleFile: false, //Limit upload to one file
            }
            return options;
        }


     },
    mounted(){
        setTimeout(()=>{
            this.hasMounted = true;
        }, 300)
    },
}
</script>

<style>

</style>
